//Libs
import * as _ from 'lodash';
//Constants
import * as ACTIONS from './actionTypes';
import { DEFAULT_PAGE_SIZE } from './constants'
//Types
import { DealerEngineCategories, LMcategories } from './types';
import { ActionEditLiveCategory, ActionGetLMCategoriesAPISuccess, ActionPostLMCategoriesAPISuccess } from './actions';
//Types
import { EngineCategory } from './types';
import { ActionEditEngineCategorySearchQuery, ActionEditSelectedEngineCategory, ActionGetEngineCategoryApiSuccess } from './actions';

export interface EngineCategoryState {
    originalDealerCategories?: DealerEngineCategories
    recommendedDealerCategories?: DealerEngineCategories
    liveDealerCategories?: DealerEngineCategories
    enginecategories?: EngineCategory[]
    showRecommended?:boolean
    page: number,
    query: string,
    limit: number,
    lastPageSize?: number

}

const defaultState: EngineCategoryState = {
    enginecategories: undefined,
    page: 0,
    query: "",
    limit: DEFAULT_PAGE_SIZE,
};

type GetLMCategoriesAction = ActionGetLMCategoriesAPISuccess | ActionPostLMCategoriesAPISuccess | ActionEditLiveCategory;
type EngineCategoryAction = ActionGetEngineCategoryApiSuccess | ActionEditEngineCategorySearchQuery | ActionEditSelectedEngineCategory

function categoriesReducer(state: EngineCategoryState = defaultState, action: GetLMCategoriesAction): EngineCategoryState {
    switch (action.type) {
        case ACTIONS.GET_LMCATEGORIES_API_SUCCESS:
            {
                const {
                    engineCategories,
                    recommendedCategories,
                    showRecommended
                } = (action as ActionGetLMCategoriesAPISuccess).lmcategories
                let liveDealerCategories: DealerEngineCategories | undefined = undefined
                if (!(engineCategories && !engineCategories.primaryCategory.id && !engineCategories.primaryCategory.name && !engineCategories.additionalCategories)) {
                    liveDealerCategories = engineCategories;
                }
                return {
                    ...state,
                    recommendedDealerCategories: recommendedCategories,
                    liveDealerCategories: liveDealerCategories ? { ...liveDealerCategories } : undefined,
                    originalDealerCategories: liveDealerCategories ? { ...liveDealerCategories } : undefined,
                    showRecommended: showRecommended,                                    

                }


            }
        case ACTIONS.POST_LMCATEGORIES_API_SUCCESS:
            {
                const {engineCategories} = (action as ActionPostLMCategoriesAPISuccess)
                return {
                    ...state,
                    originalDealerCategories: engineCategories ? { ...engineCategories } : undefined
                }
            }
        case ACTIONS.GET_ENGINECATEGORY_API_SUCCESS:
            {
                const { page } = (action as ActionGetEngineCategoryApiSuccess)
                const apiEngineCategories = (action as ActionGetEngineCategoryApiSuccess).enginecategories
                const { enginecategories } = state;
                const newEngineCategories = _.uniqBy([...( (page??0)>0?enginecategories ?? []:[]), ...apiEngineCategories], 'id');                
                return {
                    ...state,
                    enginecategories: newEngineCategories,
                    page: page ?? 0,
                    lastPageSize: apiEngineCategories?.length
                }
            }
        case ACTIONS.ENGINECATEGORY_LOAD_MORE:
            {
                return {
                    ...state,
                    page: state.page + 1
                }
            }
        case ACTIONS.EDIT_ENGINECATEGORY_SEARCH_QUERY:
            {
                const { query } = action as ActionEditEngineCategorySearchQuery;
                return {
                    ...state,
                    enginecategories: query === state.query ? state.enginecategories : [],
                    page: 0,
                    query
                }
            }
        case ACTIONS.EDIT_LIVE_CATEGORIES:
            {
                const { category } = action as ActionEditLiveCategory
                return {
                    ...state,
                    liveDealerCategories: category ? { ...category } : undefined
                }
            }
        default: {
            return {
                ...state
            }
        }
    }

}


export default categoriesReducer